import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CareTEamService } from 'src/app/services/care-team.service';
import { modelCareTeam, Results, AddCareTeamModel, CareTeam, UpdateCareTeamModel, getZipCode } from 'src/app/models/careteam/careteam';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-care-team',
  templateUrl: './care-team.component.html',
  styleUrls: ['./care-team.component.css']
})
export class CareTeamComponent implements OnInit {
  patientPersonalInfo!: PatientPersonalInfo;
  pageNum:any;
  totalPages: any;
  isEditInfoSection: boolean;
  isAddCareTeamBySearch: boolean = false;
  isMaincareTeamsection: boolean;
  bydafaultPCP: any;
  @ViewChild('scrll') private myScrollContainer: ElementRef;
  @ViewChild('scrllSearch') private myScrollContainerSearch: ElementRef;
  constructor(private translateService: TranslateService, private _location: Location, private changeRef: ChangeDetectorRef, private service: CareTEamService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private router: Router) {
    let info = localStorage.getItem('PersonalInfo');
    if(!info){
      this.router.navigateByUrl("/");
      return;
    }
    this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
    let pagesorder=localStorage.getItem('pagesorder');
    this.pageNum =JSON.parse(pagesorder?pagesorder:'').careteam;
    this.totalPages=localStorage.getItem('totalPages');
  }
  
  addCareTeamForm = new UntypedFormGroup({});
  
  ngOnInit(): void {
    //console.log(this.patientPersonalInfo);
    this.getCareteam();
    this.reset();
    this.phrUtils.setTitle('Care Team');
  }
  selectedOption: string = 'PCP'; 
  relation: string='PCP';
  //new design
  onSelect(event: any) {
    const option = (event.target as HTMLSelectElement)?.value; 
    if (option) {
      this.selectedOption = option; 
    }
    if (this.selectedOption === 'Referring Provider') {
      this.translateService.get('careteam.referring_provider').subscribe((translation: string) => {
        this.relation = translation;
      });
    } else {
      this.relation='PCP'
    }
    if (this.selectedOption === 'O') {
      this.careTeamMemberOption = 'O'
    }
    this.dNone = true;
    this.searchStr=''
  }


  //creat careteam form
  
  buildCareTeamForm() {
    this.addCareTeamForm = new UntypedFormGroup({
      FIRST_NAME: new UntypedFormControl('', [Validators.required, Validators.maxLength(35)]),
      LAST_NAME: new UntypedFormControl('', [Validators.required, Validators.maxLength(35)]),
      ADDRESS: new UntypedFormControl('', Validators.required),
      ZIP: new UntypedFormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(5)]),
      CITY: new UntypedFormControl('', Validators.required),
      STATE: new UntypedFormControl(''),
      EMAIL: new UntypedFormControl('', Validators.email),
      SPECIALITY: new UntypedFormControl('', Validators.maxLength(30)),
      RELATIONTOPATIENT: new UntypedFormControl('', Validators.required),
      RELATION: new UntypedFormControl(''),
    });
  }
  
  backClick(){
    this.router.navigateByUrl('patient/updateinfo')
  }
  
  nextClick(){
    this.router.navigateByUrl('patient/insurance')
  }
  backToMainCare() {
    if (this.careteams.length == 10) {
      this.phrUtils.showInfo("Maximum 10 care teams can be added.");
      return;
    }
    this.searchStr = '';
    this.selectedOption = "PCP";
    //this.results = [];
    this.dNone = true;
    this.isEditInfoSection = false;
    this.isMaincareTeamsection = true;
    this.isAddCareTeamBySearch = false;
    this.relation = 'PCP';
    console.log(this.dNone);
  }
  backtoEditcare() {
    this.isAddCareTeamBySearch = false;
    this.isEditInfoSection = true;
    this.isMaincareTeamsection = false;
    this.selectedOption = 'PCP';
  }
  backToaddUpdate(){
    this.isAddCareTeamBySearch = true;
    this.isMaincareTeamsection = false;
    this.isEditInfoSection = false;
}

  validateRelation(e: any) {
    if(e.target.value.length == 100){
      return false;
    }
    var charCode = (e.which) ? e.which : e.keyCode;
    if(charCode == 32){
      return true;
    }
    else{
      return this.phrUtils.onlyCharacters(e);
    }
  }
  

  validateName(e: any) {
    let val = e.target.value.replace(/[^a-zA-Z]/g, "");
    e.target.value = val;
  }
  
  onlyCharAllow(event: any,type:any) {
    if(event.value.trim())
    {
      let validname=event.value.replace(/[^a-zA-Z ]/g, "");
      event.value=validname;
    }
    else
    {
      event.value = event.value.trim();
      this.addCareTeamForm.controls[type].setValue(event.value);
    }    
  }
  
  //reset careteam formm
  reset() {
    this.addCareTeamForm.reset();
    this.buildCareTeamForm();
    this.removeStateCity();
    this.selectedOption = 'PCP'
    this.dNone = true;
  }
  
  //get CareTeamForm
  get getCareTeamForm() {
    return this.addCareTeamForm.controls;
  }
  
  // get patient care team
  careteams: CareTeam[] = [];
  getCareteam() {
    if (!this.patientPersonalInfo) {
      this._location.back();
    }
    
    this.spinner.show();
    let dto = {
      PATIENT_ACCOUNT: '' + this.patientPersonalInfo.PATIENT_ACCOUNT,
      PRACTICE_CODE: this.patientPersonalInfo.PRACTICE_CODE,
      NPIFlag: false,
      SEARCH_TEXT: "",
    }
    
    this.service.getCareTeam(dto).subscribe((res: any) => {
      this.spinner.hide();
      if(res.RESPONSE.message){
        console.log('Token has been expired.');
        return;
      }
      if (res && res.RESPONSE.length > 0) {
        this.careteams = res.RESPONSE as CareTeam[];
        this.isEditInfoSection = true;
        this.isAddCareTeamBySearch = false;
        this.isMaincareTeamsection = false;
      }
      else{
        this.careteams = [];
        this.careteams.length = 0;
        this.isEditInfoSection = false;
        this.isAddCareTeamBySearch = false;
        this.isMaincareTeamsection = true;
      }
    },
    (error: any) => {
      this.spinner.hide();
    });
  }
  
  // field blur
  noRecs: boolean = false;
  onBlur() {
    if (this._searchedCareTeam.length < 1) {
      this.noRecs = true;
    }
    else {
      this.noRecs = false;
    }
  }
  
  // search care team
  searchingSpecialist: boolean = false;
  _searchedCareTeam: modelCareTeam[] = [];
  searchStr!: string;
  results: Results[] = [];
  dNone: boolean = true;
  searchCareTeam(event: any) {
    this.searchStr = event.target.value;
    this.dNone = this.searchStr.length >= 3 ? false : true;
    if (this.searchStr == "") {
      this.searchingSpecialist = false;
      this.results = [];
      this.results.length = 0;
      this.noRecs = false;
      return;
    }
    
    let dto = {
      PatientAccount: this.patientPersonalInfo.PATIENT_ACCOUNT,
      Number: "",
      FirstName: "",
      LastName: ""
    }
    
    if (this.searchStr.trim().length == 10 && !this.searchStr.trim().includes(' ') && Number(this.searchStr)) {
      dto.FirstName = "";
      dto.LastName = "";
      dto.Number = this.searchStr.trim();
    }
    else {
      let name = this.searchStr.trim();
      let fullName = name.trim().split(' ');
      dto.FirstName = fullName[0];
      if (fullName.length > 1) {
        dto.LastName = fullName[1];
      }
    }
    
    this.searchingSpecialist = true;
    this.results = [];
    
    this.service.SearchProvider(dto).subscribe((res: any) => {
      if (res) {
        this.results = res.data.results as Results[];
        this.results.forEach((val, index) => {
          val.addresses[0].postal_code = this.phrUtils.maskingZipNum(val.addresses[0].postal_code);
        });
        if (this.results.length == 0) {
          this.noRecs = true;
        }
        else {
          this.noRecs = false;
        }
        this.searchingSpecialist = false;
      }
    },
    (error: any) => {
      this.searchingSpecialist = false;
      this.noRecs = true;
      this.results = [];
    });
  }
  
  
  onlyNumberAllow(e: any): boolean {
    e.target.value = e.target.value.replace(/\D/g, '');
    e.target.value = this.phrUtils.maskingZipNum(e.target.value);
    if (e.target.value.length == 10 || e.target.value.length == 5) {
      this.GetZipCityState(e);
      return false;
    }
    if(e.target.value.length <5 || e.target.value.length  < 10){
      this.removeStateCity();
    }

    const charCode = (e.which) ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    else {
      return true;
    }
  }
  
  
  // zip functions
  getCityState: getZipCode[] = [];
  GetZipCityState(e: any) {
    let v = e.target.value;
    if (v.length < 5) {
      return;
    }
    this.spinner.show();
    this.service.GetZipCityState(v, this.patientPersonalInfo.PATIENT_ACCOUNT, this.patientPersonalInfo.PRACTICE_CODE).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200 && res.data.length > 0) {
        this.getCityState = res.data as getZipCode[];
        this.addCareTeamForm.controls["CITY"].setValue(this.getCityState[0].cityName);
        this.addCareTeamForm.controls["STATE"].setValue(this.getCityState[0].stateCode);
        this.updateCareteam.CITY = this.getCityState[0].cityName;
        this.updateCareteam.STATE = this.getCityState[0].stateCode;
        this.addcareteam.CITY = this.getCityState[0].cityName;
        this.addcareteam.STATE = this.getCityState[0].stateCode;
      }
      else if (res.statusCode == 404) {
        this.addCareTeamForm.controls["ZIP"].setErrors({ zipNotFound: true });
        this.removeStateCity();
      }
      else {
        this.addCareTeamForm.controls["ZIP"].setErrors({zipNotFound:true});
        this.removeStateCity();
      }
    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        // this.phrUtils.showError("Service is not available, please try later.");
      });
  }
  
  removeStateCity() {
    this.getCityState = [];
    this.getCityState.length = 0;
    this.addCareTeamForm.controls["CITY"].setValue('');
    this.addCareTeamForm.controls["STATE"].setValue('');
    this.updateCareteam.CITY = '';
    this.updateCareteam.STATE = '';
    this.addcareteam.CITY = '';
    this.addcareteam.STATE = '';
  }
  
  showState(e: any) {
    let c = e.target.value;
    this.getCityState.map(city => {
      if (city.cityName === c) {
        this.addCareTeamForm.controls["STATE"].setValue(city.stateCode);
      }
    });
  }
  
  //process update care team
  ShowError(){
    if (this.careteams.length == 10) {
      let text = "Maximum 10 care teams can be added.";
      this.translateService.get('Alerts.maximum_careTeam').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showInfo(text);
    //this.phrUtils.showInfo("Maximum 10 care teams can be added.");
      return;
    }
    $('#newCareModal').modal('show');
  }
  
  _addcareteam: AddCareTeamModel = new AddCareTeamModel();
  AddCareTeam() {
   
    this.addCareTeamForm.markAllAsTouched();
    this.setRealtionOther()
    
    if (this._addcareteam.OTHER) {
      console.log("other");
      this._addcareteam.RELATION = this.addCareTeamForm.controls["RELATION"].value;
    }
    else if(this._addcareteam.PCP){
      this._addcareteam.RELATION = "Primary Care Provider (PCP)";
    }
    else if(this._addcareteam.REFERRINGPROVIDER){
      this._addcareteam.RELATION = "Referring Provider";
    }

    
    this._addcareteam.ADDRESS = this.addCareTeamForm.controls['ADDRESS'].value;
    this._addcareteam.LAST_NAME = this.addCareTeamForm.controls['LAST_NAME'].value;
    this._addcareteam.FIRST_NAME = this.addCareTeamForm.controls['FIRST_NAME'].value;
    this._addcareteam.ZIP = this.addCareTeamForm.controls['ZIP'].value;
    this._addcareteam.CITY = this.addCareTeamForm.controls['CITY'].value;
    this._addcareteam.STATE = this.addCareTeamForm.controls['STATE'].value;
    this._addcareteam.EMAIL = this.addCareTeamForm.controls['EMAIL'].value;
    this._addcareteam.SPECIALITY = this.addCareTeamForm.controls['SPECIALITY'].value;
    
    this._addcareteam.PATIENT_ACCOUNT = this.patientPersonalInfo.PATIENT_ACCOUNT;
    this._addcareteam.PRACTICE_CODE = Number(this.patientPersonalInfo.PRACTICE_CODE);
    
    if(this._addcareteam.FIRST_NAME == '' || this._addcareteam.ZIP == '' || this._addcareteam.LAST_NAME == '' || this._addcareteam.ADDRESS ==''){
      this.scrlTo(false);
      console.log("check data");
      return;
    }
  
    if(!this._addcareteam.OTHER && !this._addcareteam.REFERRINGPROVIDER && !this._addcareteam.PCP){
      this.scrlTo(true);
      console.log("check relation");
      return;
    }
    if(this._addcareteam.RELATION == ""){
      return;
    }


    

    //if (this.addCareTeamForm.invalid) {
    //  console.log("invalid");
    //  return;
    //}
    this.spinner.show();
    this.service.addCareTeam(this._addcareteam).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.RESPONSE.MESSAGE) {
        this._addcareteam = new AddCareTeamModel();
        $('#newCareModal').modal('hide');
        this.getCareteam();
        let text = "Care team has been created.";
        this.translateService.get('Alerts.careTeam_created').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showSuccess(text);
        //this.phrUtils.showSuccess("Care team has been created.");
        this.reset();
        this.isOthers = false;
      }
      else {
        let text = "Some error occured.";
        this.translateService.get('Alerts.error_occured').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Some error occured.");
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }
  

  scrlTo(isScrollBottom: boolean){
    if(isScrollBottom){
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    }
    else{
      this.myScrollContainer.nativeElement.scrollTop = 0;
    }
  }
  scrlToSerchTeam(isScrollBottom: boolean){
    if(isScrollBottom){
      this.myScrollContainerSearch.nativeElement.scrollTop = this.myScrollContainerSearch.nativeElement.scrollHeight;
    }
    else{
      this.myScrollContainerSearch.nativeElement.scrollTop = 0;
    }
  }

  isOthers: boolean = false;
  isRelationOther(e: any) {
    let v = e.target.defaultValue;
    let checked = e.target.checked;
    if (v == 'OTHER' && checked) {
      this.isOthers = true;
    }
    else {
      this.isOthers = false;
      this.getCareTeamForm["RELATION"].setValue('');
    }
    this._addcareteam.REFERRINGPROVIDER = v == 'RP' ? true : false;
    this._addcareteam.PCP = v == 'PCP' ? true : false;
    this._addcareteam.OTHER = v == 'OTHER' ? true : false;
    this.changeRef.markForCheck();
  }
  
  //setup ceare team to delete
  dtoDelete: any;
  cTeamDeleted: CareTeam = new CareTeam();
  SetCareTeamDelete(cteam: CareTeam) {
    this.dtoDelete = {
      CARE_TEAM_ID: '' + cteam.PatientCareTeamID,
      PATIENT_ACCOUNT: '' + cteam.PATIENT_ACCOUNT,
      PRACTICE_CODE: '' + cteam.PRACTICE_CODE,
      MODIFIED_BY: '' + cteam.FIRSTNAME
    }
    this.cTeamDeleted = cteam;
    if (this.cTeamDeleted.RELATION === 'Referring Provider') {
      this.translateService.get('careteam.referring_provider').subscribe((translation: string) => {
        this.relation = translation;
      });
    } else if (this.cTeamDeleted.RELATION === 'Primary Care Provider (PCP)') {
      this.relation = 'PCP'
    } else {
      this.relation = this.cTeamDeleted.RELATION;
    }
    $('#deleteCareTeamModal').modal('show');
  }
  
  // process delete care team
  DeleteCareTeam() {
    if (!this.dtoDelete) {
      return;
    }
    
    this.spinner.show();
    this.service.deleteCreTeam(this.dtoDelete).subscribe((res: any) => {
      
      this.spinner.hide();
      $('#deleteCareTeamModal').modal('hide');
      if (res && res.RESPONSE.MESSAGE) {
        this.careteams.forEach((item, index) => {
          if (item === this.cTeamDeleted) {
            this.careteams.splice(index, 1);
            let text = "Care Team deleted successfully.";
            this.translateService.get('Alerts.careTeam_deleted').subscribe((translation: string) => {
              text = translation;
            });
            this.phrUtils.showSuccess(text);
            //this.phrUtils.showSuccess("Care Team deleted successfully.")
            this.dtoDelete = null;
          }
        });
        if (this.careteams.length > 0) {
          this.isEditInfoSection = true;
          this.isAddCareTeamBySearch = false;
          this.isMaincareTeamsection = false;
        } else {
          this.isEditInfoSection = false;
          this.isAddCareTeamBySearch = false;
          this.isMaincareTeamsection = true;
          this.selectedOption = 'PCP';
          this.dNone = true;
        }
        console.log(this.careteams.length+" careTeamLength");
        // this.phrUtils.showSuccess("");
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }
  
  // update care team
  isRelationOtherUpdate(e: any) {
    let v = e.target.defaultValue;
    this.updateCareteam.REFERRINGPROVIDER = v == 'RP' ? true : false;
    this.updateCareteam.PCP = v == 'PCP' ? true : false;
    this.updateCareteam.OTHER = v == 'OTHER' ? true : false;
    if(v !="OTHER"){
      this.updateCareteam.RELATION = "";
    }
  }

  updateCareTeamSection: boolean = false;
  updateCareteam: UpdateCareTeamModel = new UpdateCareTeamModel;
  RELATIONTOPATIENTUPDATE: String = "";
  relationReqUpdate: boolean = false;
  SetCareTeamUpdate(c: CareTeam) {
    this.updateCareTeamSection = true;
    this.relationReqUpdate = false;
    this.updateCareteam.LAST_NAME = c.LASTNAME;
    this.updateCareteam.FIRST_NAME = c.FIRSTNAME;
    this.updateCareteam.STATE = c.State;
    this.updateCareteam.CITY = c.City;
    this.updateCareteam.ZIP = c.Zip;
    this.updateCareteam.REFERRINGPROVIDER = c.REFERRINGPROVIDER;
    this.updateCareteam.RELATION = c.RELATION;
    this.updateCareteam.PATIENT_ACCOUNT = this.patientPersonalInfo.PATIENT_ACCOUNT;
    this.updateCareteam.PRACTICE_CODE = Number(this.patientPersonalInfo.PRACTICE_CODE)
    this.updateCareteam.CITY = c.City;
    this.updateCareteam.EMAIL = c.EMAIL ? c.EMAIL : "";
    this.updateCareteam.NPI = c.NPI;
    this.updateCareteam.OTHER = c.OTHER;
    this.updateCareteam.PCP = c.PCP;
    this.updateCareteam.TITLE = c.TITLE;
    this.updateCareteam.ADDRESS = c.ADDRESS;
    this.updateCareteam.SPECIALITY = c.SPECIALITY;
    this.updateCareteam.PATIENT_CARE_TEAM_ID = '' + c.PatientCareTeamID;
    console.log("updateOther" + this.updateCareteam.PCP);
    if(!this.updateCareteam.OTHER){
      this.updateCareteam.RELATION = '';
    }
    
    this.emError = false;
    //console.log(this.updateCareteam);
    this.backToaddUpdate();
   // this.showModal('#UpdateCareTeamMoodal');
    this.changeRef.markForCheck();
  }
  
  showModal(modal: string){
    $(modal).modal('show');
  }
  
  //process update care team
  UpateCareTeam() {
    this.relationReqUpdate = false;
    
    if (this.updateCareteam.OTHER == true) {
      if(this.updateCareteam.RELATION =='')
      return;
    }
    else{
      if(this.updateCareteam.PCP){
        this.updateCareteam.RELATION = "Primary Care Provider (PCP)";
      }
      if(this.updateCareteam.REFERRINGPROVIDER){
        this.updateCareteam.RELATION = "Referring Provider";
      }
    }
    if(this.updateCareteam.FIRST_NAME =='' || this.updateCareteam.LAST_NAME == ''  || this.updateCareteam.ZIP == '' || this.updateCareteam.ADDRESS == '' || this.updateCareteam.CITY == '')
    {
      return;
    }

    if(this.updateCareteam.EMAIL.length > 0)
    {
      let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      let v = regexp.test(this.updateCareteam.EMAIL);
      if(!v)
      {
        this.emError = true;
        return;
      }
    }
    this.spinner.show();
    //console.log(this.updateCareteam);
    this.service.updateCareteam(this.updateCareteam).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.RESPONSE.MESSAGE) {
        this.getCareteam();
        let text = "Care team has been updated successfully.";
        this.translateService.get('Alerts.careTeam_updated').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showSuccess(text);
        //this.phrUtils.showSuccess("Care team has been updated successfully.");
        $('#UpdateCareTeamMoodal').modal('hide');
        //this.isAddCareTeamBySearch = false;
        this.updateCareteam = new UpdateCareTeamModel();
        this.removeStateCity();
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        // this.phrUtils.showError("Service is not available, please try later.");
      }
      
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      // this.phrUtils.showError("Service is not available, please try later.");
    });
  }
  setRelationCareTeam() {
    this.selectedOption === 'Referring Provider' ? this.addcareteam.REFERRINGPROVIDER = true : false;
    this.selectedOption === 'PCP' ? this.addcareteam.PCP = true : false;
      //this.selectedOption === 'FC' ? this.addcareteam.REFERRINGPROVIDER = true : false;
    this.selectedOption === 'O' ? this.addcareteam.OTHER = true : false;
    console.log(this.addcareteam.OTHER+"set other");

  }

  setRealtionOther() {
    //this.selectedOption = this.careTeamMemberOption;
    this.careTeamMemberOption === 'Referring Provider' ? this._addcareteam.REFERRINGPROVIDER = true : false;
    this.careTeamMemberOption === 'PCP' ? this._addcareteam.PCP = true : false;
    this.careTeamMemberOption === 'O' ? this._addcareteam.OTHER = true : false;
  }
  careTeamMemberOption: any='O';
  addcareTeamManually(option:any) {
    this.selectedOption = 'O'
    if (option === 'rp') {
      this.careTeamMemberOption = 'Referring Provider';
    } else if (option === 'pcp') {
      this.careTeamMemberOption = 'PCP';
    } else {
      this.careTeamMemberOption = 'O';
    }
      
  }

  //set careteam
  isOthersEdit = false;
  isRelationOtherEdit(e: any) {
    let v = e.target.defaultValue;
    this.addcareteam.REFERRINGPROVIDER = v == 'RP' ? true : false;
    this.addcareteam.PCP = v == 'PCP' ? true : false;
    this.addcareteam.OTHER = v == 'OTHER' ? true : false;
    if(!this.addcareteam.OTHER){
      this.addcareteam.RELATION = '';
    }
    this.relRequired = false;
  }
  ShowAddConfirmationModal() {
    $('#confirmAddcareTeam').modal('show');
  }
  addcareteam: AddCareTeamModel = new AddCareTeamModel();
  SetCareTeam(res: Results) {
    if (this.careteams.length == 10) {
      let text = "Maximum 10 care teams can be added.";
      this.translateService.get('Alerts.maximum_careTeam').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Maximum 10 care teams can be added.", "ERROR");
      return;
    }
    if (res) {
      this.updateCareTeamSection = false;
      this.addcareteam.ADDRESS = res.addresses[0].address_1.toLowerCase();
      this.addcareteam.LAST_NAME = res.basic.last_name.toLowerCase();
      this.addcareteam.FIRST_NAME = res.basic.first_name.toLowerCase();
      this.addcareteam.ZIP = res.addresses[0].postal_code;
      this.addcareteam.CITY = res.addresses[0].city.toLowerCase();
      this.addcareteam.PHONE = res.addresses[0].telephone_number;
      this.addcareteam.STATE = res.addresses[0].state;
      this.addcareteam.SPECIALITY = res.taxonomies[0].desc;
      this.addcareteam.NPI = String(res.number);
      this.addcareteam.TITLE = "";
      this.addcareteam.PATIENT_ACCOUNT = this.patientPersonalInfo.PATIENT_ACCOUNT;
      this.addcareteam.PRACTICE_CODE = Number(this.patientPersonalInfo.PRACTICE_CODE)
      this.setRelationCareTeam();
      this.ShowAddConfirmationModal();
     // this.SaveCareTeam();
      //this.isAddCareTeamBySearch = true;
      //this.isMaincareTeamsection = false;
      //this.isEditInfoSection = true;
     // $('#EdtCareMoodal').modal('show');
      this.emError1 = false;
      this.changeRef.markForCheck();
    }
  }
  
  // save care team from search item click
  relRequired: boolean = false;
  SaveCareTeam() {

    if(this.addcareteam.OTHER){
      if(this.addcareteam.RELATION == ''){
        this.scrlToSerchTeam(true);
        return;
      }
    }
    else {
      if(this.addcareteam.REFERRINGPROVIDER){
        this.addcareteam.RELATION = 'Referring Provider';
      }
      if(this.addcareteam.PCP){
        this.addcareteam.RELATION = 'Primary Care Provider (PCP)';
      }
    }
    if (this.addcareteam.RELATION == "") {
      this.relRequired = true;
      this.scrlToSerchTeam(true);
      return;
    }
    else{
      this.relRequired = false;
    }

    if(!this.addcareteam.PCP && !this.addcareteam.REFERRINGPROVIDER && !this.addcareteam.OTHER){
      this.scrlToSerchTeam(true);
    }

    if(this.addcareteam.CITY == '' || this.addcareteam.STATE == '' || this.addcareteam.ADDRESS
     == '' || this.addcareteam.FIRST_NAME == '' || this.addcareteam.LAST_NAME == ''){
      this.scrlToSerchTeam(false);
      return;
     }

    if(this.emError1)
    {
      return;
    }
    
    this.emError1 = false;
    this.spinner.show();
    this.service.addCareTeam(this.addcareteam).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.RESPONSE.MESSAGE) {
        let text = "Care team has been created.";
        this.translateService.get('Alerts.careTeam_created').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showSuccess(text);
        //this.phrUtils.showSuccess("Care team has been created.");
        $('#EdtCareMoodal').modal('hide');
        $('#b').prop('checked', false);
        $('#n').prop('checked', false);
        $('#t').prop('checked', false);
        this.getCareteam();
        this.addcareteam = new AddCareTeamModel();
        this.removeStateCity();
        this.selectedOption = "S";
        this.isMaincareTeamsection = false;
        this.isEditInfoSection = true;
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.selectedOption = "S";
      }
    }, (error: any) => {
      this.spinner.hide();
      if (error.error.RESPONSE.error) {
        let text = "Care Team already exists.";
        this.translateService.get('Alerts.careTeam_already_exist').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showInfo(text);
      }
      //this.phrUtils.showInfo("Care Team already exists.")
      console.log(error)
      //if (error.error.status === 400) {
      //  //console.log(error.error.RESPONSE.error);
      //  this.phrUtils.showInfo("Care Team already exists.")
      //  this.selectedOption = "S";
      //}
      //else {
      //  console.log(error.error );
      //  console.log(error.error.RESPONSE  );
      //  console.log( error.error.RESPONSE.error);
      //  this.phrUtils.showError("Service is not available, please try later2.");
      //  this.selectedOption = "S";
      //}
    });
  }
  
  // ************* validation functions *************
  limitChars(e: any, length: number) {
    e.target.value = e.target.value.replace(/[^a-zA-Z]/g, "");
    if(e.target.value.length === length){
      return false;
    }
    return true;
  }
  
  limitCharsOnly(e: any, length: number) {
    e.target.value = e.target.value;
    if(e.target.value.length === length){
      return false;
    }
    return true;
  }

  emError = false;
  valEmail(e: any) {
    let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    let v = regexp.test(e.target.value);
    if(v){
      this.emError = false;
    }
    else{
      this.emError = true;
    }
    return true;
  }

  emError1 = false;
  valEmailSearchAdd(e: any) {
    let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    let v = regexp.test(e.target.value);

    if(v){
      this.emError1 = false;
    }
    else{
      this.emError1 = true;
    }
    return true;
  }

  valEmailCreate(e: any) {
    if(e.target.value.length > 0 && !e.target.value.includes('@')){
      this.getCareTeamForm['EMAIL'].setErrors({'invalid': true});
    }
    return true;
  }
  
}
